document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
  var messages = bar.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;

  var prevBtn = bar.querySelector('[data-announcement-prev]');
  var nextBtn = bar.querySelector('[data-announcement-next]');
  var current = 0;
  var intervalTime = parseInt(bar.getAttribute('data-autoplay-speed'), 10) || 4000;
  var timer;

  function show(index) {
    messages[current].classList.remove('is-active');
    current = (index + messages.length) % messages.length;
    messages[current].classList.add('is-active');
  }

  function next() { show(current + 1); }
  function prev() { show(current - 1); }

  function startAutoplay() {
    clearInterval(timer);
    timer = setInterval(next, intervalTime);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });
  }

  startAutoplay();
});
